<div class="flex flex-row items-center justify-between">
    <span class="flex flex-row items-center gap-5">
        <span class="font-normal text-xl mb-4">{{ title() }}</span>
        <p class="text-outline">
            {{ subtitle() }}
        </p>
    </span>
    <div class="flex flex-row items-center gap-6">
        @if (asSearch()) {
            <app-custom-search
                [initialValue]="searchValue()"
                (resetSearch)="search.emit('')"
                (search)="search.emit($event)" />
        }

        @if (asAction()) {
            <app-button
                [disabled]="!actionEnabled()"
                [icon]="['fas', 'add']"
                [label]="'add' | transloco"
                [matTooltip]="(!actionEnabled() ? 'insufficientPermissions' : '') | transloco"
                [type]="ButtonType.PRIMARY"
                (onClick)="actionClicked.emit()" />
        }
    </div>
</div>
